import React from 'react';
import Redirect from 'components/Redirect';

function SupportPage() {
    return <Redirect location="https://panelfox.freshdesk.com" text="Redirecting to Freshdesk..." />;
}

export default SupportPage;
